import { type ReactNode } from "react";
import { DesktopOnlyScreen } from "../auth";
import { useIsMobileDevice } from "../components/layout/useIsMobileDevice";

/* Blocks the gated app on mobile devices (OPSS-246, narrowed from viewport
 * width to device in OPSS-332). It sits inside RequireAuth but outside the
 * identity / flags / Stigg providers, so a blocked visitor still authenticates
 * normally (and keeps their session for the desktop visit) but fetches no
 * workspace data behind the wall. */

export function MobileGuard({ children }: { children: ReactNode }) {
  const isMobileDevice = useIsMobileDevice();

  if (isMobileDevice) return <DesktopOnlyScreen />;

  return <>{children}</>;
}
